
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ValidationMsgs, constantMsg, constantValues } from 'src/app/core/Constants/static';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent implements OnInit {

  @Output('uplaodedFiles') uplaodedFiles: EventEmitter<FileList[]> = new EventEmitter();

  @Input('submitted') submitted: boolean = false;
  @Input('progress') progress:number | null = null;

  @Input('file') file!: {
    form: FormGroup,
    formControl: string,
    fileSpec: {
      fileTypes: string[],
    }
  };

  @ViewChildren('focusedElement') focusedElement!: QueryList<ElementRef>;


  private showError: boolean = false;
  private filesizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];


  public validationArray: any[] = [];
  public requiredMsgError = ValidationMsgs.requiredMsg;
  public fileSize!: string;
  public fileUploaded: boolean = false;
  public errorMsg!: string;
  public showFiles: boolean = false;
  public files: FileList[] = [];
  public showSlider: boolean = false;
  public fileMsg=constantMsg.maxFileSize;
  private maxSize=constantValues.maxFileSize;

  constructor() { }

  private checkFileSize(size: number, typeSize: string[]): void {
    if (size <= this.maxSize && (typeSize[typeSize.length - 1].toUpperCase() === 'XLSX')) {
      this.showFiles = true;
      this.progress = 70;
      this.progress = null;
    } else {
      if (size > this.maxSize) {
        this.showError = true;
        this.errorMsg = "Maximum size allowed is 10 Mb";
        this.isScrollIntoViewNeeded();
        this.fileUploaded = false;
      } else {
        this.showError = true;
        this.errorMsg = "Invalid file type. Excel files will be supported";
        this.isScrollIntoViewNeeded();
        this.fileUploaded = false;
      }
    }
  }

  private formatBytes(bytes: number, decimals = 2): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  private isScrollIntoViewNeeded(): void {
    if (this.errorMsg) {
      setTimeout(() => {
        this.focusedElement.last?.nativeElement.scrollIntoView();
      }, 100);
    }
  }

  public ngOnInit():void {
  }

  public uploadItem(event: Event): void {
    if(event){
      const inputElement = event.target as HTMLInputElement;
      if (inputElement.files) {
        this.checkFileAndUplaod(inputElement.files);
      }
    }

  }

  public onDrop(event: DragEvent): void {
    if(event){
      if (event.dataTransfer?.files) {
        this.checkFileAndUplaod(event.dataTransfer.files);
        event.preventDefault();
      }
    }
   

  }

  private checkFileAndUplaod(file:FileList):void{
    this.files = [];
    this.fileUploaded = true;
    this.showError = false;
    this.errorMsg = '';
    this.files.push(file);
    this.uplaodedFiles.emit(this.files);
    this.fileSize = this.formatBytes(this.files[0]?.[0]?.size);
    const mb = this.files[0]?.[0].size / 1024 / 1024;
    const typeSize = this.files[0]?.[0]?.name.split('.');
    this.checkFileSize(mb, typeSize);
  }

  public onDragOver(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
  }

  public deleteFile(): void {
    this.files.splice(0, 1);
    this.file.form?.controls?.[this.file.formControl].reset();
    this.fileUploaded = false;
  }

}
